export default {"src":"/_next/static/media/SQ.cc047c9b.svg","height":18,"width":18};